import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { NetworkModel, Network } from './../../models/networks.model';

@Component({
  selector: 'app-modal-quonetwork',
  templateUrl: './modal-quonetwork.component.html',
  styles: []
})
export class ModalQuonetworkComponent implements OnInit {

  network : Network;
  formControl = new FormControl('');
  modalForm : FormGroup;
  private _networkModel = new NetworkModel;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.modalForm = this.fb.group({
      clave: [this.network ? this.network.clave : null],
      nombre: [this.network ? this.network.nombre : null],
      url: [this.network ? this.network.url : null],
      tipo: [this.network ? this.network.tipo : null],
      contactoNombre: [this.network ? this.network.contactoNombre : null],
      contactoCorreo: [this.network ? this.network.contactoCorreo : null],
      contactoTelefono: [this.network ? this.network.contactoTelefono : null],
      user: [this.network ? this.network.usuario : null],
      psw: [this.network ? this.network.password : null],
      fecha_vencimiento: [this.network ? this.network.fechaVencimiento : null],
      total: [this.network ? this.network.total : null]
    });
  }

  //Agregar dominio
  adminnetwork(){
    this.activeModal.close('Guardado datos');
    this._networkModel.createNetwork(this.modalForm.value);
  }

}
